module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    ref: "card",
    staticClass: "card-border",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "id": "report",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "page-403"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-5x"
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('NOTACESS')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('LOST')))]), _vm._v(" "), _c('p', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('GOHOME')))])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b8934d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/403.vue
// module id = 607
// module chunks = 1